import { Injectable, signal } from '@angular/core';
import { IToast, ToastTone } from '../models/toast.model';

/** Toasts globales: abajo a la derecha, 1 línea, sin botón salvo «Deshacer». Máx. 3 visibles. */
@Injectable({ providedIn: 'root' })
export class ToastService {

  readonly toasts = signal<IToast[]>([]);
  /** Alto de una barra fija inferior (asistente, diseñador, guardar en celular) para que el toast quede encima. */
  readonly offset = signal(0);
  private seq = 0;
  private timers = new Map<number, ReturnType<typeof setTimeout>>();

  // region show
  show(message: string, tone: ToastTone = 'success', action?: IToast['action']): number {
    const id = ++this.seq;
    this.toasts.update(list => [...list, { id, tone, message, action }].slice(-3));
    this.schedule(id, action ? 6000 : 4000);
    return id;
  }

  // region success
  success(message: string, action?: IToast['action']): number { return this.show(message, 'success', action); }

  // region info
  info(message: string, action?: IToast['action']): number { return this.show(message, 'info', action); }

  // region error
  error(message: string): number { return this.show(message, 'error'); }

  // region dismiss
  dismiss(id: number): void {
    clearTimeout(this.timers.get(id));
    this.timers.delete(id);
    this.toasts.update(list => list.filter(t => t.id !== id));
  }

  // region pause
  pause(id: number): void { clearTimeout(this.timers.get(id)); }

  // region resume
  resume(id: number): void { this.schedule(id, 2500); }

  private schedule(id: number, ms: number): void {
    clearTimeout(this.timers.get(id));
    this.timers.set(id, setTimeout(() => this.dismiss(id), ms));
  }
}
